import { render, staticRenderFns } from "./CurriculumListEECHeader.vue?vue&type=template&id=36043bb6&scoped=true&"
import script from "./CurriculumListEECHeader.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListEECHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListEECHeader.vue?vue&type=style&index=0&id=36043bb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36043bb6",
  null
  
)

export default component.exports